import {
  Component,
  Input,
  OnInit
}                           from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CompanyService } from './company.service';

@Component({
  selector   : 'wor-company-type',
  template: require('./company.company-type.component.html')
})
export class CompanyTypeComponent implements OnInit {
  @Input() record: any;

  className     : string;
  title         : string;

  constructor (
    public companyService    : CompanyService,
    private translateService : TranslateService
  ) {}

  ngOnInit() {
    if (this.companyService.isDealer() && !this.companyService.isBranchDealer()) {
      this.className = 'status bg-warning';
      this.title     = this.translateService.instant('JS_SPACE.DEALER.DEALER');
    }
    else if (this.companyService.isDealer() && this.companyService.isBranchDealer()) {
      this.className = 'status bg-success';
      this.title     = this.translateService.instant('JS_SPACE.DEALER.HEAD_OFFICE');
    }
    else if (this.companyService.isBranchStore()) {
      this.className = 'status bg-info';
      this.title     = this.translateService.instant('JS_SPACE.DEALER.BRANCH');
    }
  }
}